import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

import { HelperArticle } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";

import { ArticleDetail } from "../articles-details/article-detail";
import { ArticleSection } from "./helper-article-section";

export interface HelperArticleListPreviewProps {
  url: string;
  articles: HelperArticle[];
  className?: string;
  selectedArticle: HelperArticle | null;
  onArticleClick: (article: HelperArticle | null) => void;
}

export function HelperArticleListPreview({
  articles,
  url,
  className,
  selectedArticle,
  onArticleClick,
}: HelperArticleListPreviewProps) {
  const { t } = useTranslation();

  useEffect(() => {
    onArticleClick(selectedArticle);
  }, [selectedArticle, onArticleClick]);

  const featuredArticles = articles.slice(0, 1);
  const otherArticles = articles.slice(1);

  if (selectedArticle) {
    return (
      <div className={cn("flex flex-col space-y-6", className)}>
        <button
          onClick={() => onArticleClick(null)}
          className="body300-link text-primary-600 mb-4 flex items-center"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t("component.helper_article_detail.back")}
        </button>
        <ArticleDetail article={selectedArticle} />
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col space-y-6", className)}>
      <ArticleSection
        title={t("component.helper_article_preview.feature_article")}
        articles={featuredArticles}
        url={url}
        knowMore
        className="h-[150px]"
        onArticleClick={onArticleClick}
      />
      <ArticleSection
        title={t("component.helper_article_preview.other_article")}
        articles={otherArticles}
        url={url}
        knowMore={false}
        onArticleClick={onArticleClick}
      />
    </div>
  );
}
